import { Pipe, PipeTransform } from "@angular/core";
import { getPlainTextLength } from "./rich-text.utils";

@Pipe({
  name: "richTextPlainLength",
})
export class RichTextPlainLengthPipe implements PipeTransform {
  transform(value: string): number {
    return getPlainTextLength(value);
  }
}
